export default "__VITE_ASSET__fc1c0b01__"